<!-- progrem essay info -->
<template>
  <div class="program-essay-info">
    <div>
      <div v-for="(item, index) in essaysInfo"
           :key="index">
        <h1>PS / Essay 0{{index+1}}</h1>
        <div class="essay-info-item">
          <p>Tittle</p>
          <div>{{item.title}}</div>
        </div>
        <div class="essay-info-item">
          <p>Word limit</p>
          <div>{{item.count}}</div>
        </div>
        <div class="essay-info-item">
          <p>Description</p>
          <div v-html="item.description"
               class='word-break-style'>
            {{item.description}}
          </div>
        </div>
      </div>
      <div class="essay-info-item en-speaker"
           v-if="isEnglishSpeaker && userRole === 'EM'">
        <p>SM info</p>
        <div class='word-break-style'>
          <span>Native English speaker: {{isEnglishSpeaker}}</span>
          <img :src="InfoIcon"
               alt=""
               @click="nativeModal = true">
        </div>
      </div>
      <div class="essay-info-prompt"
           v-if="menteeDetail.finishBill">
        Note: All documents are uploaded
      </div>
      <!-- 弹窗 -->
      <zlr-modal v-model="nativeModal">
        <div class="native-modal">
          <p>SM info</p>
          <div>
            For Editor Mentor<br />
            If yes, essay editing time: 20 minutes for each program's complete essay set.<br />
            If no, essay editing time: actual time spent editing
          </div>
          <Button class="zlr-btn-default"
                  @click="nativeModal = falses">Close</Button>
        </div>
      </zlr-modal>
    </div>
  </div>
</template>
<script>
// api
import { getMaterialEssaysInfo } from '@/api/material'
import InfoIcon from '@/assets/images/home/Info.svg'
import { mapState } from 'vuex'
// components
import ZlrModal from '_c/modal/modal'
export default {
  name: 'mentee-program-essay-info',
  components: {
    ZlrModal
  },
  data () {
    return {
      InfoIcon,
      programId: this.$route.params.programId,
      essaysInfo: [],
      nativeModal: false,
      isEnglishSpeaker: ''
    }
  },
  computed: {
    ...mapState({
      menteeDetail (state) {
        return state.mentee.menteeDetail
      },
      userRole (state) {
        return state.user.userRole
      }
    })
  },
  mounted () {
    this.getEssaysInfo()
  },
  methods: {
    getEssaysInfo () {
      getMaterialEssaysInfo({
        id: this.programId
      }).then(res => {
        this.essaysInfo = res.data.list
        this.isEnglishSpeaker = res.data.isEnglishSpeaker
      })
    }
  }
}
</script>
<style lang='less' scoped>
.word-break-style {
  word-break: break-all;
}
.en-speaker {
  span {
    vertical-align: middle;
  }
  img {
    vertical-align: middle;
    width: 16px;
    height: 16px;
    margin-left: 24px;
    cursor: pointer;
  }
}
.native-modal {
  width: 506px;
  > p {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 36px;
    margin-bottom: 24px;
  }
  > div {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
    margin-bottom: 40px;
  }
}
</style>
